export default {"src":"/_next/static/media/hospital.858dcec6.svg","height":213,"width":171};